import { DELETE_DMX_DEVICE_PRESET, DELETE_DMX_DEVICE_PRESET_SUCCESSFUL, DELETE_DMX_DEVICE_PRESET_FAILED } from './actionTypes';

export const deleteDmxDevicePreset = (preset) => {
  return {
    type: DELETE_DMX_DEVICE_PRESET,
    payload: { preset },
  };
};

export const deleteDmxDevicePresetSuccessful = (message) => {
  return {
    type: DELETE_DMX_DEVICE_PRESET_SUCCESSFUL,
    payload: message,
  };
};

export const deleteDmxDevicePresetFailed = (message) => {
  return {
    type: DELETE_DMX_DEVICE_PRESET_FAILED,
    payload: message,
  };
};
